// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const ShortcodeWrapper = styled<any, Theme>('div')`
  color: ${props => props.theme.packageCompare.legend.color};
  display: flex;
  justify-content: flex-end;
  font-size: ${props => props.theme.packageCompare.legend.fontSize};
  padding-top: 1.5rem;
`;

export default ShortcodeWrapper;
